module.exports = __webpack_public_path__ + "img/arrow_right_outline_white.57f3b708.png";